import script from "./FilterSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSearch.vue?vue&type=script&setup=true&lang=js"

import "./FilterSearch.vue?vue&type=style&index=0&id=521bbd68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521bbd68"]])

export default __exports__